// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2uHnl","search":"Settings_search__4ept5","filter":"Settings_filter__-JeIb"};